import {
  getPage,
  getDetail,
  getClientPage,
  exportExcel,
} from '@/api/localalarmanalysisresultserv'

export default {
  state: {
    state_LocalAlarmAnalysisResult_GetPageResult: null,
    state_LocalAlarmAnalysisResult_GetDetailResult: null,
    state_LocalAlarmAnalysisResult_GetClientPageResult: null,
    state_LocalAlarmAnalysisResult_ExportExcelResult: null,
  },
  mutations: {
    SET_LOCALALARMANALYSISRESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_LocalAlarmAnalysisResult_GetPageResult = rst;
    },
    SET_LOCALALARMANALYSISRESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_LocalAlarmAnalysisResult_GetDetailResult = rst;
    },
    SET_LOCALALARMANALYSISRESULT_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_LocalAlarmAnalysisResult_GetClientPageResult = rst;
    },
    SET_LOCALALARMANALYSISRESULT_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_LocalAlarmAnalysisResult_ExportExcelResult = rst;
    },
  },
  actions: {
    LocalAlarmAnalysisResultServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_LOCALALARMANALYSISRESULT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_LOCALALARMANALYSISRESULT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    LocalAlarmAnalysisResultServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_LOCALALARMANALYSISRESULT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_LOCALALARMANALYSISRESULT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    LocalAlarmAnalysisResultServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_LOCALALARMANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_LOCALALARMANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    LocalAlarmAnalysisResultServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_LOCALALARMANALYSISRESULT_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_LOCALALARMANALYSISRESULT_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_LocalAlarmAnalysisResult_GetPageResult: state => {
      return state.state_LocalAlarmAnalysisResult_GetPageResult;
    },
    get_LocalAlarmAnalysisResult_GetDetailResult: state => {
      return state.state_LocalAlarmAnalysisResult_GetDetailResult;
    },
    get_LocalAlarmAnalysisResult_GetClientPageResult: state => {
      return state.state_LocalAlarmAnalysisResult_GetClientPageResult;
    },
    get_LocalAlarmAnalysisResult_ExportExcelResult: state => {
      return state.state_LocalAlarmAnalysisResult_ExportExcelResult;
    },
  }
}